import { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import { Header } from '../../components/Header';
import { apiNode } from '../../services/api';
import { Leagues } from '../Leagues';
import { LeaguesList } from '../LeaguesList';
import { Container, Content } from './styles';

export const LeaguesHome = () => {
  const [hasLeague, setHasLeague] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const updateUserHasLeague = async () => {
    setIsLoading(true);
    const response = await apiNode
      .get('/ligas/users')
      .catch(() => setHasLeague(false));

    response ? setHasLeague(true) : setHasLeague(false);
    setIsLoading(false);
  };

  useEffect(() => {
    try {
      const checkIfUserHasLeague = async () => {
        setIsLoading(true);
        const response = await apiNode
          .get('/ligas/users')
          .catch(() => setHasLeague(false));

        response ? setHasLeague(true) : setHasLeague(false);
        setIsLoading(false);
      };
      checkIfUserHasLeague();
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  }, []);

  return (
    <>
      {hasLeague === null ? (
        <Container>
          <Header />
          <Content />
          <Footer />
        </Container>
      ) : hasLeague ? (
        <LeaguesList updateHasLeague={updateUserHasLeague} />
      ) : (
        <Leagues updateHasLeague={updateUserHasLeague} />
      )}
    </>
  );
};
